import { useState } from "react";
import useMediaQueries from "hooks/useMediaQueries";
import Button, { ButtonA } from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";
import ContactrUsForm from "../ContactUs/ContactUsForm/ContactrUsForm.js";

const ButtonsContainer = () => {
  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();
  const [hideForm, setHideForm] = useState(true);

  return (
    <>
      <div className="buttons-container">
        <ButtonA
          buttonClass={!mobileCondition ? "no-margin-bottom" : ""}
          page="plans"
          target="_blank"
        >
          {getTextByKey("get-started-text")}
        </ButtonA>
        <Button
          transparent
          buttonClass={!mobileCondition ? "no-margin-bottom" : ""}
          onClick={() => {
            setHideForm(false);
          }}
        >
          {getTextByKey("contact-us")}
        </Button>
      </div>
      {!hideForm && <ContactrUsForm setHideForm={setHideForm} />}
    </>
  );
};

export default ButtonsContainer;
